
import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import {
    GET_COMPANIES,
    DELETE_COMPANY,
    UPDATE_COMPANY,
    TOGGLE_COMPANY_STATUS,
    ADD_NEW_COMPANY,
    GET_COMPANY_DETAIL,
    ASSIGN_PLAN,
} from "./actionTypes"

import {
    getCompaniesSuccess,
    getCompaniesFail,
    deleteCompanySuccess,
    deleteCompanyFail,
    updateCompanySuccess,
    updateCompanyFail,
    toggleCompanyStatusSuccess,
    toggleCompanyStatusFail,
    addNewCompanySuccess,
    addNewCompanyFail,
    getCompanyDetailSuccess,
    getCompanyDetailFail,
    assignPlanSuccess,
    assignPlanFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
    getCompanies,
    deleteCompany,
    updateCompany as updateCompanyApi,
    toggleCompanyStatus,
    addNewCompany,
    getCompanyDetail as getCompanyDetailApi,
    assignCompanyPlan,
} from "../../helpers/fakebackend_helper"

function* fetchCompanies() {
    try {
        const response = yield call(getCompanies)
        yield put(getCompaniesSuccess(response))
    } catch (error) {
        yield put(getCompaniesFail(error))
    }
}

function* fetchCompanyDetail({ payload: id }) {
    try {
        const response = yield call(getCompanyDetailApi, id)
        yield put(getCompanyDetailSuccess(response))
    } catch (error) {
        yield put(getCompanyDetailFail(error))
    }
}

function* onAddNewCompany({ payload: company }) {
    try {
        const response = yield call(addNewCompany, company)
        yield put(addNewCompanySuccess(response))
    } catch (error) {
        yield put(addNewCompanyFail(error))
    }
}

function* onDeleteCompany({ payload: id }) {
    try {
        yield call(deleteCompany, id)
        yield put(deleteCompanySuccess(id))
    } catch (error) {
        yield put(deleteCompanyFail(error))
    }
}

function* onUpdateCompany({ payload: company }) {
    try {
        const response = yield call(updateCompanyApi, company)
        yield put(updateCompanySuccess(response))
    } catch (error) {
        yield put(updateCompanyFail(error))
    }
}

function* onToggleCompanyStatus({ payload: id }) {
    try {
        const response = yield call(toggleCompanyStatus, id)
        yield put(toggleCompanyStatusSuccess(response))
    } catch (error) {
        yield put(toggleCompanyStatusFail(error))
    }
}

function* onAssignPlan({ payload: { id, data } }) {
    try {
        const response = yield call(assignCompanyPlan, id, data)
        yield put(assignPlanSuccess(response))
    } catch (error) {
        yield put(assignPlanFail(error))
    }
}

function* companiesSaga() {
    yield takeEvery(GET_COMPANIES, fetchCompanies)
    yield takeEvery(GET_COMPANY_DETAIL, fetchCompanyDetail)
    yield takeEvery(DELETE_COMPANY, onDeleteCompany)
    yield takeEvery(UPDATE_COMPANY, onUpdateCompany)
    yield takeEvery(TOGGLE_COMPANY_STATUS, onToggleCompanyStatus)
    yield takeEvery(ADD_NEW_COMPANY, onAddNewCompany)
    yield takeEvery(ASSIGN_PLAN, onAssignPlan)
}

export default companiesSaga
